// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-wrapper[data-v-1649a50a]{display:flex;align-items:center;justify-content:center;width:32px;height:32px;background:linear-gradient(0deg,#000,#000),#161b25;border-radius:100%}.form-title[data-v-1649a50a]{margin-bottom:15px;font-weight:500;font-size:32px;line-height:40px;color:#000}.form-text[data-v-1649a50a]{margin-bottom:30px;font-weight:400;font-size:16px;line-height:24px;color:rgba(7,6,0,.7)}", ""]);
// Exports
module.exports = exports;
